import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";

const DEFAULT_HOME_BY_ROLE = {
  admin: "/admin",
  dealer: "/dealer",
};

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email.trim().toLowerCase(), password);
    setLoading(false);
    if (res.ok) {
      toast.success(`Welcome back, ${res.user.name}!`);
      const dest = loc.state?.from || DEFAULT_HOME_BY_ROLE[res.user.role] || "/";
      nav(dest, { replace: true });
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-[80vh] grid lg:grid-cols-2" data-testid="login-page">
      <div className="hidden lg:block bg-[#0A192F] relative overflow-hidden">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/faebc29d-3b74-4c7b-9094-0a55a837aa6b/images/ff6e17b00cf241ac465f2d69fcd21f88ad933709c83459ce4ea51171c9258b0a.png"
          alt="Gaddi Junction"
          className="absolute inset-0 w-full h-full object-cover opacity-50"
        />
        <div className="absolute inset-0 gj-hero-gradient" />
        <div className="relative h-full p-16 flex flex-col justify-end text-white">
          <div className="gj-divider-gold mb-4" />
          <div className="font-heading text-4xl font-extrabold leading-tight">
            Welcome back to <br />
            <span className="text-[#F97316]">Gaddi Junction.</span>
          </div>
          <p className="mt-3 text-white/70 max-w-md">
            Manage your listings, respond to enquiries, and grow your dealership.
          </p>
        </div>
      </div>

      <div className="flex items-center justify-center px-4 py-16">
        <form onSubmit={onSubmit} className="w-full max-w-md" data-testid="login-form">
          <div className="gj-divider-gold mb-4" />
          <h1 className="font-heading text-3xl font-extrabold text-[#0A192F]">Sign in</h1>
          <p className="text-sm text-[#4A5568] mt-1">Dealers, customers, and admins.</p>

          <div className="mt-8 space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@email.com"
                required
                data-testid="login-email-input"
              />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                data-testid="login-password-input"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[#0A192F] hover:bg-[#112240] text-white py-6"
              data-testid="login-submit-btn"
            >
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </div>

          <div className="mt-6 text-sm text-[#4A5568] text-center">
            No account?{" "}
            <Link to="/register" className="text-[#0A192F] font-semibold hover:text-[#F97316]" data-testid="login-to-register">
              Create one
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
